module.exports = __webpack_public_path__ + "img/huaixiao.393d7484.png";